import i18n from 'i18n/config';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AI_NAME } from 'modules/ai/constants/aiName';
import type { State } from 'redux/initialState';

export type TranslateFn = (
  key: string, // eslint-disable-line
  options?: Record<string, any> // eslint-disable-line
) => string;

export const useTranslate = () => {
  const { t: translate, i18n } = useTranslation();
  const societyType =
    useSelector((state: State) => state.society?.actualSociety?.societyType) ||
    '';

  const t = (key: string, options = {}) =>
    translate(key, { aiName: AI_NAME, ...options, context: societyType });

  return { t, i18n };
};

export const translate = (key: string, options = {}) => {
  // eslint-disable-next-line global-require
  const { store } = require('redux/store');
  const state: State = store.getState();
  const societyType = state.society?.actualSociety?.societyType || '';
  return i18n.t(key, { aiName: AI_NAME, ...options, context: societyType });
};
